<!-- Page Banner -->
<div class="page-banner-area item-bg3">
    <div class="container">
        <div class="page-banner-content">
            <h2>UI Testing</h2>
            <ul>
                <li>
                    <a href="/">Home</a>
                </li>
                <li>UI Testing</li>
            </ul>
        </div>
    </div>
</div>
<!-- End Page Banner -->

<!-- Services Details -->
<section class="services-details-area ptb-100">
    <div class="container">
        <div class="row">
            <div class="col-lg-8 col-md-12">
                <div class="services-details-image">
                    <img src="assets/img/services-details/services-details-1.jpg" alt="image">
                </div>

                <div class="services-details-desc">
                    <h3>What is UI Testing?</h3>
                    <p>UI Testing, also known as GUI Testing is basically a mechanism meant to test the aspects of any
                        software that a user
                        will come into contact with. This usually means testing the visual elements to verify that they
                        are functioning
                        according to requirements – in terms of functionality and performance. UI testing ensures that
                        UI functions are
                        bug-free.

                        Websites comprise web elements created with CSS, JavaScript, and numerous other programming
                        languages. UI testing
                        performs tests and assertions of these elements to validate their efficacy. It is focused on
                        examining visual and
                        structural parts of the software i.e., parts the user would be concerned with, rather than the
                        internal logic of the
                        software.

                        UI Testing covers the gamut of visual indicators and graphic-based icons- toolbars, fonts,
                        menus, text boxes, radio
                        buttons, checkboxes, colors, and more.
                    </p>
                    <h3>The Scope of UI Testing</h3>
                    <p>

                        Here are a few essential test cases that UI tests tend to verify:

                        Data type errors: The test checks that only valid data can be entered for certain data fields
                        such as dates, currency,
                        etc.
                        Field widths: The test checks that certain text fields do not allow the user to place inputs
                        over a specific character
                        limit.
                        Navigational elements: The test checks that all navigational buttons on a page are working and
                        that they redirect users
                        to the right page.
                        Progress bars: The test checks that when displaying pages or screens that take time to load
                        completely, a progress bar
                        appears to let the user know that the page is loading.
                        Type-ahead: If the UI uses drop-down lists, type-ahead is required. In a drop-down menu with
                        multiple options, the user
                        should be able to find the right one by typing the first letter. Making the user go through a
                        long list constitutes an
                        unfavorable user experience.
                        Table scrolling: If the website has data tables, and if the table extends into a second page,
                        then the user should be
                        able to scroll through all the data while keeping the headers visible and in place.
                        Error Logging: This test checks that in case of a system error, the software records error
                        details to a log file so that
                        it can be reviewed later.
                        Menu Items: The test checks that the software displays only the menu available in its particular
                        geographical location
                        (if that is applicable).
                        Working shortcuts: If the software supports shortcuts, this test validates that each of them
                        works as expected across
                        multiple browsers, platforms, and devices.
                    </p>

                    <div class="services-details-features">
                        <div class="row align-items-center">
                            <div class="col-lg-6 col-md-12">
                                <div class="features-image">
                                    <img src="assets/img/services-details/services-details-2.jpg" alt="image">
                                </div>
                            </div>

                            <div class="col-lg-6 col-md-12">
                                <ul class="features-list">
                                    <li><i class="flaticon-check"></i> Functionality</li>
                                    <li><i class="flaticon-check"></i> Visual Design</li>
                                    <li><i class="flaticon-check"></i> Responsiveness</li>
                                    <li><i class="flaticon-check"></i> Performance</li>
                                    <li><i class="flaticon-check"></i> Usability</li>
                                    <li><i class="flaticon-check"></i> Accessibility</li>
                                    <li><i class="flaticon-check"></i> Compliance</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-12">
                <div class="services-details-information">
                    <ul class="services-list">
                        <li><a routerLink="/technology-expertise" class="active">Related Technology Expertise</a></li>
                        <li><a routerLink="/technology-expertise">Unit Test Cases</a></li>
                        <li><a routerLink="/technology-expertise">Bug Reports</a></li>
                        <li><a routerLink="/technology-expertise">Selenium</a></li>
                        <li><a routerLink="/technology-expertise">Java</a></li>
                        <li><a routerLink="/technology-expertise">JMeter</a></li>
                        <li><a routerLink="/technology-expertise">Jira</a></li>
                        <li><a routerLink="/technology-expertise">Azure Devops</a></li>
                    </ul>

                    <app-services-contact-info></app-services-contact-info>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Services Details -->

<!-- Services -->
<section class="services-area pb-70">
    <div class="container">
        <div class="section-title">
            <span>Services we provided</span>
            <h2>Related Services</h2>
            <div class="bar"></div>
        </div>

        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="single-services-item">
                    <div class="image">
                        <a routerLink="/manual-testing-services">
                            <img src="assets/img/services/services-7.jpg" alt="image">
                        </a>
                    </div>
                    <div class="content">
                        <h3><a routerLink="/manual-testing-services">Manual Testing</a></h3>
                        <span>Testing Type</span>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="single-services-item">
                    <div class="image">
                        <a routerLink="/api-testing-services">
                            <img src="assets/img/services/services-9.jpg" alt="image">
                        </a>
                    </div>
                    <div class="content">
                        <h3>
                            <a routerLink="/api-testing-services">API Testing</a>
                        </h3>
                        <span>Using Tool</span>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="single-services-item">
                    <div class="image">
                        <a routerLink="/database-testing-services">
                            <img src="assets/img/services/services-10.jpg" alt="image">
                        </a>
                    </div>
                    <div class="content">
                        <h3>
                            <a routerLink="/database-testing-services">Database Testing</a>
                        </h3>
                        <span>Using Queries</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Services -->